<div class="container-fluid">
    <div class="row pl--1rem8  d-flex align-items-center">
        <div class="col-md-7">
       
            <div class="page-header">
                <h2>Manage Employees</h2>
                <p>Manage existing employees or create new</p>
              </div>
        </div>
        <div class="col-md-5 d-flex justify-content-end">
            <div class="task-btn" (click)="onClickUpdateUserCount()" *ngIf="currentUserType=='Platform'">
                <button type="submit" class="btn btn-primary btn-add">
                    <i class="fa fa-user-plus" aria-hidden="true"></i> Update user count</button>
            </div>
            <div class="task-btn" (click)="createNewUser()">
                <button  type="submit" class="btn btn-primary mt-0 float-right btn-add" *ngxPermissionsOnly="['EDIT_EMPLOYEES']">
                    <i class="fa fa-plus-circle" aria-hidden="true"></i>Add Employee</button>
            </div>
        </div>
    </div>
    <div class="row d-flex align-items-center pt-2 pb-2 useListHeader">
        <div class="col-md-9 mb-0 pr-0 companyHeader">
            <h5 *ngIf="currentUserType=='Attorney' && isVisibleDetails">{{currentListCompanyName}}</h5>
            <p *ngIf="currentUserType=='Attorney' && isVisibleDetails">{{isAssociateCompany ? 'Associated Company': 'Parent Company'}}</p>
        </div>
        <div class="col-md-3 mb-0 pr-0">
          <div class="input-group float-right">
            <input class="form-control py-2 rounded-pill" type="search"
            #userListTable (input)="onSearchChange($event.target.value)"  placeholder="Search User">
            <span class="input-group-append">
              <button class="btn rounded-pill border-0 ml-n4r" type="button">
                <i class="fa fa-search"></i>
              </button>
            </span> 
          </div>
        </div>
      </div>

    <div class="mat-elevation-z8 mt-0">
        <table class="im-card-no-border-table table im-card-table-noborder-spacing table-striped-simple" mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
                <td mat-cell *matCellDef="let row">
                    <div class="row">
                        <div class="col-md-10" style="padding: 0;">
                            <div class="row">
                                {{row.firstName}}
                                <div class="ml-2" *ngIf="row?.isAuthSignatory">
                                    <img src="assets/Icon_signature.svg" matTooltip="Authorized Signatory">
                                </div>
                                <div class="ml-2" *ngIf="currentUserType=='Attorney' && isVisibleDetails && row?.isPrimaryContactPerson">
                                    <img src="assets/Icon_PrimaryContact.svg" matTooltip="Primary Contact">
                                </div> 
                            </div>
                            <div class="row">

                            </div>
                        </div>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="lastname">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> LastName </th>
                <td mat-cell *matCellDef="let row"> {{row.lastName}} </td>
            </ng-container>

            <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Company</th>
                <td mat-cell *matCellDef="let row"> {{row.company.companyName}} </td>
            </ng-container>

            <ng-container matColumnDef="designation">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Designation</th>
                <td mat-cell *matCellDef="let row"> {{row.designation}} </td>
            </ng-container>

            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                <td mat-cell *matCellDef="let row">{{row.emailContacts.length ? row.emailContacts[0].email : ''}}</td>
            </ng-container>

            <ng-container matColumnDef="action" *ngIf="currentUserType=='Attorney' && isVisibleDetails">
                <th mat-header-cell *matHeaderCellDef ><b> Action </b></th>
                <td mat-cell *matCellDef="let row" id="userListActions">
                  <button type="button" pButton icon="pi pi-cog" (click)="toggleMenu(menu,$event,row)" class="menu-button">
                    <i class="pi pi-angle-down downArrowIcon"></i>
                  </button>
                  <p-menu #menu [popup]="true" [model]="items"></p-menu>
                </td>
            </ng-container> 
            <ng-container matColumnDef="action" *ngIf="currentUserType=='Attorney' && !isVisibleDetails">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Action </th>
                <td mat-cell *matCellDef="let row">
                    <div class="row">
                        <div class="userIcons col-md-4 p-0" *ngxPermissionsOnly="['EDIT_EMPLOYEES']">                           
                            <i style="cursor: pointer;" class="material-icons" (click)="handleEdit(row)" matTooltip="Edit">
                                edit
                            </i>
                        </div>
                        <div class="col-md-1" *ngIf="showInviteButton">
                            <i style="cursor: pointer;margin-top:4px;font-size:18px;" class="fa fa-paper-plane" (click)="sendInviteToClient(row)" matTooltip="Send Invite">
                            
                            </i>
                        </div>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="action" *ngIf="currentUserType!=='Attorney'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Action </th>
                <td mat-cell *matCellDef="let row">
                    <div class="row">
                        <div class="userIcons col-md-4 p-0" *ngxPermissionsOnly="['EDIT_EMPLOYEES']">                           
                            <i style="cursor: pointer;" class="material-icons" (click)="handleEdit(row)" matTooltip="Edit">
                                edit
                            </i>
                            <!-- <i style="cursor: pointer;" class="material-icons" matTooltip="Delete" (click)="onClickDeleteUser(row)">
                                delete
                            </i> -->
                        </div>
                        <div class="col-md-1" *ngIf="showInviteButton">
                            <i style="cursor: pointer;margin-top:4px;font-size:18px;" class="fa fa-paper-plane" (click)="sendInviteToClient(row)" matTooltip="Send Invite">
                            
                            </i>
                        </div>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;">
            </tr>
        </table>
        <mat-paginator [pageSizeOptions]="[25, 50, 100]"
        [pageSize]="pageSize"
        [length]="totalElementCount"
        (page)="paginationEvent($event)"
        ></mat-paginator>
    </div>
</div>

<p-confirmDialog></p-confirmDialog>